"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.AUTOPX_DISCOUNT_ID = exports.ELECTRONIC_DISCOUNT_ID = void 0;
exports.ELECTRONIC_DISCOUNT_ID = 2;
exports.AUTOPX_DISCOUNT_ID = 3;
//# sourceMappingURL=discounts.js.map